import { usePiPWindow } from 'components/PiP/PiPProvider';
import { PipActionTile } from 'components/PiP/PipActionTile';
import { useTranslation } from 'react-i18next';

export const PiPPlaceholder = ({ floating }: { floating?: boolean }) => {
  const { t } = useTranslation('room');
  const { closePipWindow } = usePiPWindow();

  return (
    <PipActionTile
      floating={floating}
      message={t('grid.pip_placeholder')}
      actionLabel={t('grid.pip_placeholder_action')}
      onAction={() => closePipWindow()}
    />
  );
};
